import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Attachments.frontend.types'

@Injectable({ providedIn: 'root' })
export class Attachments_add_attachment_to_entity_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { entityKeys: { name?: string, value?: any }[], attachmentDetails?: { description?: string, fileName?: string }, fileContent: Blob, entityType: string }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityKeys)) {
      missingRequiredInParams.push('\'entityKeys\'');
    }
    if (isNil(inParams.fileContent)) {
      missingRequiredInParams.push('\'fileContent\'');
    }
    if (isNil(inParams.entityType)) {
      missingRequiredInParams.push('\'entityType\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Attachments/functions/add_attachment_to_entity_flow`;
    
    const options = {
    }
    
    url += `?inParams=${encodeURIComponent(JSON.stringify(omit(inParams, ['fileContent'])))}`;
    const body = inParams.fileContent;
    this.$utils.http.setBlobHeadersToHttpClientOptions(body, options);
    
    return this.$utils.http.post(url, body, options);
    
  }

}

